import React from 'react'
import logoSquareManImage from 'logo_square_man.jpg'

class Phone extends React.Component {
  constructor(props) {
    super(props)

    let newDate = new Date()
    let minutesNow = newDate.getMinutes()
    let hoursNow = newDate.getHours()

    this.state = {
      currentTime: ("0" + hoursNow).substr(-2) + ":" + ("0" + minutesNow).substr(-2)
    }

    this.setTime = this.setTime.bind(this)
    this.setMessageTime = this.setMessageTime.bind(this)
  }

  componentWillMount() {
    moment.updateLocale('en', {
      relativeTime : {
        past: function(input) {
          return input === 'now'
            ? input
            : input + ' ago'
        },
        s  : 'now',
        future: "in %s",
        ss : '%d seconds',
        m:  "1m",
        mm: "%dm",
        h:  "an hour",
        hh: "%d hours",
        d:  "a day",
        dd: "%d days",
        M:  "a month",
        MM: "%d months",
        y:  "a year",
        yy: "%d years"
      }
    })
  }

  componentDidMount() {
    let newDate = new Date()
    let $jsDialog1 = $('.js-dialog-1')

    setTimeout(function () {
      $jsDialog1.rmHidden()
      $jsDialog1.addClass('dialog-1')
      $jsDialog1.attr('data-time', newDate)
      $jsDialog1.find('.dialog-right').text(moment().startOf(newDate).fromNow())
    }, 1000)

    setTimeout(function () {
      let $jsDialog2 = $('.js-dialog-2')

      $jsDialog2.rmHidden()
      $jsDialog2.addClass('dialog-2')
      $jsDialog2.attr('data-time', newDate)
      $jsDialog2.find('.dialog-right').text(moment().startOf(newDate).fromNow())
    }, 5000)

    setInterval(this.setTime, 1000)
    setInterval(this.setMessageTime, 1000)
  }

  setTime() {
    let newDate = new Date()
    let minutesNow = newDate.getMinutes()
    let hoursNow = newDate.getHours()

    this.setState({ currentTime: ("0" + hoursNow).substr(-2) + ":" + ("0" + minutesNow).substr(-2) })
  }

  setMessageTime() {
    let $jsDialog1 = $('.js-dialog-1')
    let $jsDialog2 = $('.js-dialog-2')
    let dateTime1 = $jsDialog1.data('time')
    let dateTime2 = $jsDialog2.data('time')

    $jsDialog1.find('.dialog-right').text(moment(new Date(dateTime1)).fromNow())
    $jsDialog2.find('.dialog-right').text(moment(new Date(dateTime2)).fromNow())
  }

  render() {
    return (
      <div className="phone-flex">
        <div  className="phone-wrapper">
          <div className="phone-scale">
            <div className="phone-date-time">
              <div className="phone-time">
                { this.state.currentTime }
              </div>
              <div className="phone-date">
                { new Date().toLocaleString('en-En',{weekday: "long", month: "long", day: "numeric"}) }
              </div>
            </div>
            <div className="phone-dialog-box js-dialog-1 hidden">
              <div className="background-blur"></div>
              <div className="header">
                <div className="contents">
                  <div className="dialog-left">
                    <img src={logoSquareManImage} className="mr5" /><span className="app-name">SERVICESEEKING</span>
                  </div>
                  <div className="dialog-right">
                    now
                  </div>
                </div>
              </div>
              <div className="contents main-content">
                Olivia from Sydney just posted a job
              </div>
            </div>
            <div className="phone-dialog-box js-dialog-2 hidden">
              <div className="background-blur"></div>
              <div className="header">
                <div className="contents">
                  <div className="dialog-left">
                    <img src={logoSquareManImage} className="mr5" /><span className="app-name">SERVICESEEKING</span>
                  </div>
                  <div className="dialog-right">
                    now
                  </div>
                </div>
              </div>
              <div className="contents main-content">
                <strong>
                  New message from Mike
                </strong>
                <br/>
                Thanks for your quote. Are you free on Friday afternoon?
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Phone
